__turbopack_context__.v({
  "active": "obB2Sq_active",
  "activeContent": "obB2Sq_activeContent",
  "content": "obB2Sq_content",
  "fullWidth": "obB2Sq_fullWidth",
  "shimmer": "obB2Sq_shimmer",
  "simpleTabs": "obB2Sq_simpleTabs",
  "sticky": "obB2Sq_sticky",
  "tab": "obB2Sq_tab",
  "tabContent": "obB2Sq_tabContent",
  "tabs": "obB2Sq_tabs",
  "text-bar-sweep": "obB2Sq_text-bar-sweep",
});
